import { useEffect, useState } from "react";
import "./SplashScreen.css";

const HERO = "/images/hero/hero.png";
const LOGO = "/logo.png";

export default function SplashScreen({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const duration = 2000;
    const interval = 20;
    const steps = duration / interval;
    let current = 0;

    const timer = setInterval(() => {
      current += 1;
      setProgress(Math.min(Math.round((current / steps) * 100), 100));
      if (current >= steps) {
        clearInterval(timer);
        setFading(true);
        setTimeout(onDone, 500);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [onDone]);

  return (
    <div className={`splash${fading ? " splash--fade" : ""}`}>
      <div className="splash-bg" style={{ backgroundImage: `url(${HERO})` }} />
      <div className="splash-overlay" />
      <div className="splash-content">

        {/* Brand */}
        <div className="splash-brand">
          <img src={LOGO} alt="GDM Installations" className="splash-logo-img" />
          <span className="splash-brand-sub">Wood Installations</span>
        </div>

        <div className="splash-divider" />

        <p className="splash-tagline">
          Lavorazioni artigianali in legno<br />Zona Bari e dintorni
        </p>

        <div className="splash-bar-wrap">
          <div className="splash-bar" style={{ width: `${progress}%` }} />
        </div>
        <span className="splash-percent">{progress}%</span>
      </div>
    </div>
  );
}
